import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductDocument.Find.IRequest;
type Response = Api.Core.ProductDocument.Find.IResponse;
type Headers = Api.Core.ProductDocument.Find.IHeaders;
const url = '/api/ProductManagement/ProductDocument/:documentId';
export default async function productDocumentFindApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, body),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
